import { ck, URLS } from "fire-wind-water";
// import { getGlobalUserId } from "../../stempcore/src/core/client";
import commonService from "@/services/commonService.js";
import { getUserAgentInfo } from "@/common/utils.js";

export function verifyLogin(data,  jumpLogin= true) {
  console.log("# verifyLogin");
  if (!checkLogin(data.schemaId)) {
    if (jumpLogin) {
      getLoginUrl(data, redirectToLogin);
    }
    return false;
  } else {
    return true;
  }
}

export function checkLogin(schemaId) {
  let memberId = ck.cookie("smarketMember_" + schemaId);
  if (memberId != "" && memberId != null) {
    return true;
  } else {
    return false;
  }
}

function getLoginUrl({ tenantId, registerFormId, clientType, weChatId }, cb) {
  let info = {
    tenantId: tenantId,
    memberFormId: registerFormId,
    isObtainLink: 1
  };
  commonService.getRegistrationForm(info).subscribe(data => {
    let form = data.content;
    let loginUrl = form.originUrl[clientType];
    loginUrl += loginUrl.indexOf("?") > -1 ? "&" : "?";
    if (URLS.getURL("markCode")) {
      loginUrl += "markCode=" + URLS.getURL("markCode") + "&";
    }
    if (URLS.getURL("memberFormId")) {
      loginUrl += "memberFormId=" + registerFormId + "&";
    }
    if (getUserAgentInfo().isWeChat) {
      //是在微信中打开
      if (weChatId) {
        loginUrl += "weChatId=" + weChatId + "&";
      }
    }
    cb(loginUrl);
  });
}

function redirectToLogin(loginUrl) {
  // TODO: 保留哪些url信息？
  let backUrl = window.location.href;
  let urlstr = URLS.updateSearchParam(
    "sourceKey",
    URLS.getURL("sourceKey"),
    loginUrl
  );
  urlstr = URLS.updateSearchParam(
    "backUrl",
    encodeURIComponent(backUrl),
    urlstr
  );
  window.$sk.goto(urlstr);
}
